import { Upload, Form, Input, Button, message } from 'antd';
import { UploadOutlined, FilePdfOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useState } from 'react';
import { uploadPdfArticle } from 'api/articleservice';

const PdfUploader = ({ onUpload, articleId }) => {
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();

  const beforeUpload = (file) => {
    setFileList([file]); // فقط اضافه کن به لیست
    return false; // جلوگیری از آپلود خودکار
  };

  const onRemove = () => {
    setFileList([]);
  };

  const uploadPdf = async ({ file, PDFPageCount }) => {
    const formData = new FormData();
    formData.append('pdf', file);
    formData.append('PDFPageCount', PDFPageCount);
    formData.append('articleId', articleId)
    try {
      const response = await uploadPdfArticle(formData);
      message.success('Upload successful!');
      console.log('Server response:', response.data);
    } catch (error) {
      message.error('Upload failed!');
      // console.error('Error uploading PDF:', error);
    }

  };

  const handleSubmit = async () => {
    try {
      await form.validateFields(); // بررسی تعداد صفحات
      if (!fileList.length) {
        message.error('Please choose a PDF file.');
        return;
      }

      const values = form.getFieldsValue();
      //onUpload?.({ file: fileList[0], PDFPageCount: values.pageCount });
      await uploadPdf({ file: fileList[0], PDFPageCount: values.pageCount });

      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (err) {
      // ارورهای فرم به‌صورت خودکار توسط AntD هندل می‌شن
    }
  };

  return (
    <Form form={form} layout="vertical">
      <Form.Item label="">
        <Upload
          accept=".pdf"
          beforeUpload={beforeUpload}
          fileList={fileList}
          showUploadList={false}
          customRequest={() => { }}
          onRemove={onRemove}
        >
          <Button icon={<UploadOutlined />}>Choose File</Button>
        </Upload>

        {fileList.length > 0 && (
          <div
            style={{
              marginTop: 10,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: 8,
              background: '#fafafa',
              borderRadius: 6,
              border: '1px solid #e0e0e0',
            }}
          >
            <FilePdfOutlined style={{ fontSize: 20, color: '#e53935' }} />
            <span>{fileList[0].name}</span>
            <Button size="small" type="text" danger onClick={onRemove}>
              Remove
            </Button>
          </div>
        )}
      </Form.Item>

      <Form.Item
        label={
          <>
            Number of Pages
          </>
        }
        name="pageCount"
        rules={[
          { required: true, message: 'Please enter the number of pages' },
          { pattern: /^[1-9]\d*$/, message: 'Only positive numbers allowed' },
        ]}
      >
        <Input type="number" min={1} placeholder="Enter number of pages" />
      </Form.Item>

      <Button
        type="primary"
        onClick={handleSubmit}
        disabled={!fileList.length}
      >
        Upload PDF
      </Button>
    </Form>
  );
};

export default PdfUploader;
